import i18n from '../i18n';
import { moneyLocale } from './money';

/**
 * A percentage as KollabHR writes it, in the Canadian variant of the app
 * language: "85%" in English, "85 %" in French (a no-break space before the
 * sign, so it never wraps away from the number). Never glue a "%" or " %"
 * to a number by hand: one of the two languages then reads wrong (English
 * demo videos showed "85 %", 2026-10-12). Tests `frontend/tests/percent-format.test.tsx`.
 */

export interface PercentOptions {
  /** Digits after the decimal mark at most (default 1: "85.5%", "85%"). */
  maximumFractionDigits?: number;
  /** `'exceptZero'` for a change: "+3%", "-2%", "0%". */
  signDisplay?: 'auto' | 'exceptZero';
}

/**
 * Formats a value already on the 0 to 100 scale (85 reads "85%").
 * `language` defaults to the current app language.
 */
export function formatPercent(
  value: number,
  language?: string | null,
  { maximumFractionDigits = 1, signDisplay = 'auto' }: PercentOptions = {}
): string {
  return new Intl.NumberFormat(moneyLocale(language || i18n.language), {
    style: 'percent',
    maximumFractionDigits,
    signDisplay,
  }).format(value / 100);
}
